import AccountVerifyForm from './AccountVerifyForm';

export default AccountVerifyForm;
